import { render } from "./CompanyDetailsJobsTab.vue?vue&type=template&id=0c2a3a40"
import script from "./CompanyDetailsJobsTab.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsJobsTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__